import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const SLOTS = [
  { key: "morning", label: "Morning", icon: "Sunrise" },
  { key: "afternoon", label: "Afternoon", icon: "Sun" },
  { key: "night", label: "Night", icon: "Moon" },
];

// ISO week key: YYYY-Www, week starts Monday
export function getWeekKey(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = (d.getUTCDay() + 6) % 7; // Mon=0
  d.setUTCDate(d.getUTCDate() - dayNum + 3); // Thursday
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const week = 1 + Math.round(((d - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
  return `${d.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
}

export function getMonday(date) {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function fmtDate(date) {
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function weekRangeLabel(monday) {
  const sunday = addDays(monday, 6);
  return `${fmtDate(monday)} – ${fmtDate(sunday)}, ${sunday.getFullYear()}`;
}

// Prayer session lifecycle derived from started_at + completed
export function sessionStatus(entry) {
  if (entry.completed) return "completed";
  if (entry.started_at) return "in_progress";
  return "not_started";
}

export const ANSWER_STATUSES = [
  { key: "in_progress", label: "In progress" },
  { key: "unanswered", label: "Not yet answered" },
  { key: "answered", label: "Answered" },
];

export const URGENCY_LEVELS = [
  { key: "high", label: "High", color: "#B4553F" },
  { key: "medium", label: "Medium", color: "#C4A47C" },
  { key: "low", label: "Low", color: "#8A9485" },
];

export function urgencyMeta(key) {
  return URGENCY_LEVELS.find((u) => u.key === key) || URGENCY_LEVELS[1];
}

export function answerStatusOf(entry) {
  return entry.answer_status || (entry.answered ? "answered" : "unanswered");
}

export function minutesSince(iso) {
  if (!iso) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
}

export function formatElapsed(iso) {
  const mins = minutesSince(iso);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ${mins % 60}m`;
  return `${Math.floor(hrs / 24)}d`;
}

export function daysSince(iso) {
  if (!iso) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));
}

export function waitingLabel(iso) {
  const d = daysSince(iso);
  if (d === 0) return "Added today";
  if (d === 1) return "Waiting 1 day";
  return `Waiting ${d} days`;
}

export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

// A gentle nudge to encourage commitment for prayers not yet started
export function nudgeFor(entry, isToday) {
  if (sessionStatus(entry) !== "not_started") return null;
  if (isToday && entry.time_of_prayer) {
    const now = new Date();
    const [h, m] = entry.time_of_prayer.split(":").map(Number);
    const set = new Date();
    set.setHours(h || 0, m || 0, 0, 0);
    if (now > set) return "Your set time has passed — it's never too late to begin.";
    return "Set for today — a quiet moment awaits you.";
  }
  return "Set but not yet started — will you begin?";
}

export { axios };
